export default function Card({ title, content }) {
  return (
    <div className="card mx-3 mb-3">
      <div className="card-body p-1">
        <h2 className="font-semibold text-center mt-2">{title}</h2>
        <p className="text-gray-600 text-center mb-2">{content}</p>
      </div>
    </div>
  );
}
